import type { ReactNode } from 'react';

interface DmShellLayoutProps {
    title: string;
    onBack?: () => void;
    /** Inside a host panel (e.g. a sidebar tab) there is nowhere to go back to: no header. */
    embedded?: boolean;
    /** The children lay out their own padding and scrolling, e.g. a pinned footer under a scrolling editor. */
    bleed?: boolean;
    /** Right side of the header, in place of the balancing spacer, e.g. a mark-as-read button. */
    headerRight?: ReactNode;
    children: ReactNode;
}

function contentClass(embedded: boolean, bleed: boolean): string {
    if (bleed) return 'flex-1 min-h-0 flex flex-col';
    return `flex-1 min-h-0 overflow-auto ${embedded ? 'p-4' : 'p-6'}`;
}

function DmShellLayout({
    title,
    onBack,
    embedded = false,
    bleed = false,
    headerRight,
    children
}: DmShellLayoutProps) {
    return (
        <div className="flex flex-col flex-1 min-h-0">
            {!embedded && (
                <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200 flex-shrink-0">
                    <button
                        onClick={onBack}
                        className="text-sm font-semibold text-gray-600 hover:text-gray-800 transition-colors"
                    >
                        ← Back
                    </button>
                    <div className="text-sm font-semibold text-gray-800">{title}</div>
                    {headerRight ?? <div className="w-[60px]" />}
                </div>
            )}
            <div className={contentClass(embedded, bleed)}>{children}</div>
        </div>
    );
}

export { DmShellLayout };
